import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { t } from 'i18next';

/**
 * A functional component that renders an input field for the health system number.
 **/
export const TextFieldHealthSystemNumber = ({ values, handleChange }) => (
    <TextField
        fullWidth
        label={t('users.fields.healthNumber')}
        type="tel"
        name="healthSystemNumber"
        value={values.healthSystemNumber}
        onChange={handleChange}
    />
);

TextFieldHealthSystemNumber.propTypes = {
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired
};
